import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-popup-connection-error',
  templateUrl: './popup-connection-error.component.html',
  styleUrls: ['./popup-connection-error.component.scss']
})
export class PopupConnectionErrorComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PopupConnectionErrorComponent>,
  ) { }

  ngOnInit() {
  }

  onCloseDialog(event?: Event) {
    this.dialogRef.close();
  }

  onReload() {
    window.location.reload();
  }
}
